<div ng-controller="servicesController as ctrl">
    <div id="managed-component"></div>
</div>